<template>
    <!-- Content -->
    <div class="container-xxl mt-5" id="blogA">
        <div class="row justify-content-between p-0 m-0 d-none d-lg-flex">
            <div class="col-6 text-start">
                <h4>{{ $t("fundacion.aquanautas_vuelve") }}</h4>
                <p class="col-10 mt-5 txtGris">{{ $t("fundacion.la_relajacion") }}</p>
                <h5 class="mt-5">
                    <localized-link to="/fundacion-we-are-water#blogNews">
                        <img :src="`${publicPath}img/fletxaL.png`" class="img-responsive me-3">
                        <span style="vertical-align: middle">{{ $t("fundacion.volver") }}</span>
                    </localized-link>
                </h5>

            </div>
            <div class="col-6 p-0 m-0">
                <img :src="`${publicPath}img/fundacionB.jpg`" class="img-responsive">
            </div>
        </div>
        <div class="row d-block d-lg-none">
            <div class="col-12 text-start">
                <h3>{{ $t("fundacion.aquanautas_vuelve") }}</h3>
                <p class="mt-5 txtGris">{{ $t("fundacion.la_relajacion") }}</p>
                <img :src="`${publicPath}img/fundacionB.jpg`" class="img-responsive">
            </div>
            <div class="col-12 text-start">
                <h5 class="my-5">
                    <localized-link to="/fundacion-we-are-water#blogNews">
                        <img :src="`${publicPath}img/fletxaL.png`" class="img-responsive me-3">
                        <span style="vertical-align: middle">{{ $t("fundacion.volver") }}</span>
                    </localized-link>
                </h5>

            </div>
        </div>
    </div>

    <!-- end Content -->

</template>


<script>
    export default {
        name: "WeAreWaterDiaMundialAguaView",
        data() {
            return {
                publicPath: process.env.BASE_URL
            }
        }
    }

</script>
